import { useEffect } from 'react';
import { fetchMe } from '../containers/Login/api';
import {
  loggedinUser,
  logoutAction,
  useSessionStore,
} from '../stores/sessionStore';
import { purgeLegacyAuthStorage, saveState } from '../utils/persistState';

/** Restore session from httpOnly cookie via GET /auth/me. */
export function useSessionBootstrap() {
  useEffect(() => {
    let cancelled = false;

    purgeLegacyAuthStorage();

    (async () => {
      try {
        const response = await fetchMe();
        if (cancelled) {
          return;
        }
        if (response.status === 401) {
          logoutAction();
          return;
        }
        const user = response.data;
        if (user?.id != null) {
          saveState(user);
          loggedinUser(user);
        }
      } catch {
        if (!cancelled) {
          logoutAction();
        }
      } finally {
        if (!cancelled) {
          useSessionStore.setState({ sessionHydrated: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);
}
